export interface IBusinessInformation {
  name: string;
  businessName: string;
  numberOfEmployees: string;
}

export const COLOR_OPTIONS = {
  GREY: 'grey',
  WHITE: 'white',
  FLORALWHITE: 'floralwhite',
} as const;

export interface IVariant {
  WHITE: {
    backgroundColor: string;
  };
  GREY: {
    backgroundColor: string;
  };
  FLORALWHITE: {
    backgroundColor: string;
  };
}
